import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolonavalacabbooking() {



const cardData =
{
  keyword: 'Pune to Lonavala Cab Booking',
  heading: 'Lotus Cab: Pune to Lonavala Cab Booking',
 headingDescription:
    "Lotus Cabs offers reliable and affordable Pune to Lonavala Cab services for family vacations, weekend getaways, sightseeing tours, corporate outings, honeymoon trips, and one-way or round-trip travel. We provide a premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Pune, well-maintained vehicles, and safe travel through the scenic Mumbai–Pune Expressway, Lotus Cabs ensures a comfortable, enjoyable, and hassle-free journey to Lonavala.",



  top: 'Top Places to Visit in Lonavala with Lotus Cab',

  topPlaces: [
    {
        title: "Bhushi Dam",
        description:
            "Bhushi Dam is one of Lonavala's most visited attractions, especially during the monsoon season when overflowing water creates a refreshing natural experience. Families, couples, and groups traveling from Pune enjoy relaxing by the flowing water, capturing beautiful photographs, and spending quality time amidst the lush green surroundings and cool hill station climate."
    },
    {
        title: "Tiger Point",
        description:
            "Tiger Point is a spectacular hilltop viewpoint famous for breathtaking views of deep valleys, mist-covered mountains, and dramatic cliffs of the Sahyadri range. It is a favorite destination for sunrise and sunset lovers, photographers, and nature enthusiasts looking to experience the scenic beauty of Lonavala."
    },
    {
        title: "Rajmachi Fort",
        description:
            "Rajmachi Fort is a historic Maratha fort surrounded by dense forests and rolling hills, making it a popular destination for trekking and adventure enthusiasts. Visitors traveling from Pune explore the fort for its historical significance, panoramic viewpoints, and peaceful natural environment throughout the year."
    },
    {
        title: "Karla Caves",
        description:
            "Karla Caves are ancient Buddhist rock-cut caves dating back over 2,000 years and are among Maharashtra's finest examples of early Buddhist architecture. Travelers visit the caves to admire their impressive carvings, magnificent prayer hall, and rich cultural heritage while enjoying scenic hill views."
    },
    {
        title: "Bhaja Caves",
        description:
            "Bhaja Caves are another remarkable group of ancient Buddhist caves known for intricate sculptures, historic inscriptions, and beautifully carved prayer halls. Located amidst lush greenery, the caves attract history lovers, photographers, and travelers interested in Maharashtra's rich archaeological heritage."
    },
    {
        title: "Lohagad Fort",
        description:
            "Lohagad Fort is one of the most popular forts near Lonavala, offering scenic trekking trails, impressive fortifications, and panoramic views of the surrounding valleys. During the monsoon season, the fort becomes exceptionally beautiful with lush green landscapes and mist-covered pathways attracting thousands of visitors."
    },
    {
        title: "Lion's Point",
        description:
            "Lion's Point is a famous viewpoint offering uninterrupted views of valleys, waterfalls, and mountain ranges. The cool breeze, roadside food stalls, and spectacular sunset views make it one of the most enjoyable places for tourists visiting Lonavala from Pune."
    },
    {
        title: "Pawna Lake",
        description:
            "Pawna Lake is a peaceful lakeside destination known for camping, boating, photography, and relaxing weekend escapes. Surrounded by hills and historic forts, it is a favorite destination for families, couples, and adventure seekers looking to enjoy nature close to Lonavala."
    },
    {
        title: "Della Adventure Park",
        description:
            "Della Adventure Park is one of India's leading adventure destinations, offering a wide range of activities including ATV rides, ziplining, paintball, bungee jumping, and luxury resort experiences. It is a perfect destination for families, corporate groups, and adventure enthusiasts visiting Lonavala."
    },
    {
        title: "Kune Waterfalls",
        description:
            "Kune Waterfalls is one of the highest waterfalls in Maharashtra and is famous for its three-tier cascade, lush green surroundings, and tranquil atmosphere. The waterfall becomes especially attractive during the monsoon season, providing visitors with excellent photography opportunities and a refreshing natural escape."
    }
],

  "services": [
    {
      "name": "Pune to Lonavala Cab Booking",
      "description": "Book Pune to Lonavala Cab Booking with Lotus Cab for safe and comfortable hill-station travel. Our service ensures timely pickup anywhere in Pune, professional drivers trained for expressway and ghat driving, and clean air-conditioned vehicles. Whether for weekend relaxation or corporate outing, we provide transparent pricing and flexible travel packages. Customers can choose sedan or SUV options based on group size and luggage needs. With 24/7 booking support and punctual service, your Lonavala trip becomes smooth and stress-free."
    },
    {
      "name": "Pune to Lonavala Taxi Service",
      "description": "Our Pune to Lonavala Taxi Service offers reliable, affordable, and comfortable transportation through scenic routes. Ideal for daily travelers and weekend tourists, we ensure safe driving and professional service standards."
    },
    {
      "name": "Pune to Lonavala One Way Cab",
      "description": "Affordable one-way cab option allowing travelers to pay only for the drop journey without return charges. Perfect for hotel check-ins and short stays."
    },
    {
      "name": "Pune to Lonavala Round Trip Taxi",
      "description": "Flexible round-trip cab service with customizable return timing for maximum convenience."
    },
    {
      "name": "Pune to Lonavala Weekend Cab",
      "description": "Special weekend cab packages designed for quick getaways and family trips."
    },
    {
      "name": "Affordable Pune to Lonavala Cab",
      "description": "Budget-friendly pricing without compromising comfort or safety."
    },
    {
      "name": "Luxury Cab Pune to Lonavala",
      "description": "Premium sedan and SUV options for executive and luxury travel."
    },
    {
      "name": "SUV Taxi Pune to Lonavala",
      "description": "Spacious SUV option ideal for families and group outings."
    },
    {
      "name": "Best Cab Service Pune to Lonavala",
      "description": "Top-rated cab service known for punctuality and customer satisfaction."
    }
  ],

  "tableData": [
    ["Pune to Lonavala Cab Booking", "Pune to Lonavala Taxi Service"],
    ["Pune to Lonavala One Way Cab", "Pune to Lonavala Round Trip Taxi"],
    ["Pune to Lonavala Weekend Cab", "Affordable Pune to Lonavala Cab"],
    ["Luxury Cab Pune to Lonavala", "SUV Taxi Pune to Lonavala"],
    ["Cheap Pune to Lonavala Taxi", "Online Cab Booking Pune to Lonavala"],
    ["Best Cab Service Pune to Lonavala", "Pune to Lonavala Expressway Cab"],
    ["Pune to Lonavala Family Trip Cab", ""]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Experienced Ghat Drivers",
      "WhyChoosedescription": "Our drivers are trained for safe hill driving, ensuring smooth navigation through curves and expressway routes even during monsoon conditions."
    },
    {
      "WhyChooseheading": "Transparent Pricing",
      "WhyChoosedescription": "We provide clear fare structure with no hidden charges and complete billing transparency before booking confirmation."
    },
    {
      "WhyChooseheading": "Comfortable AC Vehicles",
      "WhyChoosedescription": "Clean, air-conditioned sedan and SUV vehicles ensure comfortable travel."
    },
    {
      "WhyChooseheading": "Flexible Travel Options",
      "WhyChoosedescription": "Choose one-way or round-trip packages based on your travel plan."
    },
    {
      "WhyChooseheading": "24/7 Booking Support",
      "WhyChoosedescription": "Round-the-clock assistance and instant booking confirmation."
    },
    {
      "WhyChooseheading": "Perfect for Weekend Trips",
      "WhyChoosedescription": "Special packages designed for short vacations."
    },
    {
      "WhyChooseheading": "Family-Friendly Service",
      "WhyChoosedescription": "Spacious vehicles for safe and comfortable family travel."
    },
    {
      "WhyChooseheading": "On-Time Pickup Guarantee",
      "WhyChoosedescription": "We ensure punctual pickup and timely arrival at your destination."
    }
  ]
}

const faqData = [
  { question: 'Do you provide one-way cab from Pune to Lonavala?', answer: 'Yes, we offer affordable one-way and round-trip options.' },
  { question: 'Is expressway route used?', answer: 'Yes, we use Mumbai–Pune Expressway for faster and safer travel.' },
  { question: 'Are SUVs available?', answer: 'Yes, SUV and sedan options are available.' },
  { question: 'Is pricing transparent?', answer: 'Yes, no hidden charges.' },
  { question: 'Is weekend booking available?', answer: 'Yes, weekend and holiday bookings available.' },
  { question: 'Is ghat driving safe?', answer: 'Yes, drivers are experienced in hill driving.' },
  { question: 'Are vehicles AC?', answer: 'Yes, all vehicles are fully air-conditioned.' },
  { question: 'Is advance booking required?', answer: 'Advance booking is recommended during peak season.' },
  { question: 'Do you offer family packages?', answer: 'Yes, family trip cab packages are available.' },
  { question: 'Is night travel safe?', answer: 'Yes, verified drivers ensure safe night travel.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sagar Kulkarni',
    feedback: 'Booked Lotus Cab for weekend trip to Lonavala. Driver was very professional and handled ghat roads smoothly. Car was clean and comfortable throughout the journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Neha Patil',
    feedback: 'Family trip to Bhushi Dam and Tiger Point was wonderful. Transparent pricing and timely pickup made our experience stress-free.',
    rating: 5
  }
];












































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Lonavala Cab",
"image": "https://lotuscab.com/assets/images/pune-to-lonavala-cab.jpg",
"description": "Book Pune to Lonavala Cab with Lotus Cab for affordable, safe, and comfortable travel. One way and round trip taxi service with Sedan, SUV, Hatchback, and AC cabs available 24x7 with instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "6143"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-lonavala-cab"
}
};









  return (
    <div>
      

<Helmet>
  <title>Pune to Lonavala Cab | One Way & Round Trip Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Lonavala Cab with Lotus Cab at affordable fares. One way and round trip taxi service with Sedan, SUV, Hatchback, and AC cabs, experienced drivers, instant booking, and 24x7 customer support."
/>

<meta
 name="keywords"
 content="Pune to Lonavala Cab, Pune to Lonavala Taxi, Pune to Lonavala Cab Service, Pune to Lonavala Taxi Service, Lonavala Cab from Pune, One Way Cab Pune to Lonavala, Round Trip Cab Pune to Lonavala, Outstation Cab Pune to Lonavala, Pune to Lonavala Car Rental, Affordable Pune to Lonavala Cab, Cheap Pune to Lonavala Taxi, Online Pune to Lonavala Cab Booking, Sedan Cab Pune to Lonavala, SUV Cab Pune to Lonavala, AC Cab Pune to Lonavala, Best Pune to Lonavala Cab, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolonavalacabbooking;